module.exports = __webpack_public_path__ + "static/ariston_1024-b4ce5e7e6d01af3e4440e13f1685387c.png";